<template>
  <div class="search-equipment-page bg-white mb-3">
    <header class="text-left bg-primary-2 search_equipment d-flex user-detail">
      <div class="search_equipment-company d-flex justify-content-between mx-3 mx-lg-auto align-items-center">
        <div>
          <p class="mb-0 text-white f-12 o-5">{{ equipment.type }}</p>
          <p class="mb-0 text-white f-24 font-weight-bold">{{ equipment.unit_no }}</p>
        </div>
        <svg v-if="equipment.type === 'Vehicle'" width="49" height="30" viewBox="0 0 49 30" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M39.8056 21.9471C37.5793 21.9471 35.7681 23.7538 35.7681 25.9736C35.7681 28.1938 37.5793 30 39.8056 30C42.0314 30 43.8431 28.1938 43.8431 25.9736C43.8431 23.7538 42.0314 21.9471 39.8056 21.9471ZM39.8056 27.1578C39.1506 27.1578 38.6181 26.6268 38.6181 25.9736C38.6181 25.3204 39.1506 24.7893 39.8056 24.7893C40.4606 24.7893 40.9931 25.3204 40.9931 25.9736C40.9931 26.6268 40.4606 27.1578 39.8056 27.1578Z"
            fill="white" />
          <path
            d="M39.4188 5.21022H32.4429C31.918 5.21022 31.4929 5.63469 31.4929 6.15762V24.6318C31.4929 25.1548 31.918 25.5792 32.4429 25.5792H33.4504C33.9207 25.5792 34.3373 25.2415 34.398 24.7764C34.7709 21.9275 37.0495 20.1607 39.8059 20.1607C42.5623 20.1607 44.8409 21.9276 45.2138 24.7764C45.2746 25.2415 45.6907 25.5792 46.1614 25.5792H47.1679C47.6923 25.5792 48.1179 25.1548 48.1179 24.6318V15.3947C48.1179 15.1721 48.0395 14.957 47.8965 14.787L40.1473 5.54986C39.967 5.33484 39.7 5.21022 39.4188 5.21022ZM33.3929 12.7894V8.05241C33.3929 7.52948 33.818 7.10501 34.3429 7.10501H38.5277C38.8093 7.10501 39.0768 7.23009 39.2573 7.44604L43.2154 12.183C43.7308 12.8002 43.291 13.7368 42.4854 13.7368H34.3429C33.818 13.7368 33.3929 13.3129 33.3929 12.7894Z"
            fill="white" />
          <path
            d="M1.56792 25.5797H4.00044C4.47071 25.5797 4.88727 25.2419 4.94804 24.7768C5.3209 21.928 7.59951 20.1611 10.3559 20.1611C13.1123 20.1611 15.3909 21.928 15.7638 24.7768C15.8246 25.242 16.2407 25.5797 16.7114 25.5797H28.643C29.1674 25.5797 29.593 25.1552 29.593 24.6323V0.947396C29.593 0.42447 29.1674 0 28.643 0H1.56792C1.04302 0 0.61792 0.42447 0.61792 0.947396V24.6323C0.61792 25.1553 1.04302 25.5797 1.56792 25.5797Z"
            fill="white" />
          <path
            d="M10.3556 21.9471C8.12933 21.9471 6.31812 23.7538 6.31812 25.9736C6.31812 28.1938 8.12933 30 10.3556 30C12.5815 30 14.3931 28.1938 14.3931 25.9736C14.3931 23.7538 12.5815 21.9471 10.3556 21.9471ZM10.3556 27.1578C9.70064 27.1578 9.16812 26.6268 9.16812 25.9736C9.16812 25.3204 9.70064 24.7893 10.3556 24.7893C11.0106 24.7893 11.5431 25.3204 11.5431 25.9736C11.5431 26.6268 11.0106 27.1578 10.3556 27.1578Z"
            fill="white" />
        </svg>
        <svg v-else-if="equipment.type === 'Trailer'" width="50" height="30" viewBox="0 0 50 30" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M34.1447 25.1162C34.1447 22.419 36.3719 20.2325 39.1192 20.2325C41.8666 20.2325 44.0938 22.419 44.0938 25.1162C44.0938 27.8135 41.8666 30 39.1192 30C36.372 30 34.1447 27.8135 34.1447 25.1162ZM41.2511 25.1162C41.2511 23.9603 40.2967 23.0232 39.1192 23.0232C37.9418 23.0232 36.9873 23.9603 36.9873 25.1162C36.9873 26.2722 37.9418 27.2092 39.1192 27.2092C40.2967 27.2093 41.2511 26.2723 41.2511 25.1162ZM22.7745 25.1162C22.7745 22.419 25.0016 20.2325 27.749 20.2325C30.4964 20.2325 32.7235 22.419 32.7235 25.1162C32.7235 27.8135 30.4964 30 27.749 30C25.0016 30 22.7745 27.8135 22.7745 25.1162ZM29.8809 25.1162C29.8809 23.9603 28.9264 23.0232 27.749 23.0232C26.5716 23.0232 25.6171 23.9603 25.6171 25.1162C25.6171 26.2722 26.5716 27.2092 27.749 27.2092C28.9264 27.2092 29.8809 26.2723 29.8809 25.1162Z"
            fill="white" />
          <path fill-rule="evenodd" clip-rule="evenodd"
            d="M23.5995 18.8373H43.2691L45.3482 22.4093C45.5415 22.7414 45.9813 22.8615 46.3252 22.6686L47.5477 21.9828C47.8969 21.7869 48.0118 21.3609 47.8162 21.0248L46.543 18.8374H47.6471C48.432 18.8374 49.0684 18.2127 49.0684 17.442V1.39536C49.0684 0.624713 48.432 0 47.6471 0H2.16602C1.38104 0 0.744717 0.624713 0.744717 1.39536V17.4418C0.744717 18.2125 1.38104 18.8372 2.16602 18.8372H3.58732V20.9367C3.58732 21.3132 3.9085 21.6279 4.30463 21.6279H5.71253C6.11479 21.6279 6.42983 21.3184 6.42983 20.9367V18.8372H20.3255L19.0522 21.0246C18.8589 21.3567 18.9768 21.7897 19.3208 21.9826L20.5432 22.6684C20.8924 22.8643 21.3246 22.7453 21.5202 22.4091L23.5995 18.8373Z"
            fill="white" />
        </svg>


      </div>
    </header>
    <div class="mt-6rem mx-3 mx-lg-auto">
      <div v-if="showInfo">
        <div v-if="equipment.unit_no">
          <div class="d-flex mt-2 align-items-center">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M17.7188 9.84375H15.6292C15.7028 9.63769 15.75 9.4185 15.75 9.1875V3.28125C15.75 2.19581 14.8667 1.3125 13.7812 1.3125H7.875C6.78956 1.3125 5.90625 2.19581 5.90625 3.28125V9.1875C5.90625 9.4185 5.9535 9.63769 6.027 9.84375H3.28125C2.19581 9.84375 1.3125 10.7271 1.3125 11.8125V17.7188C1.3125 18.8042 2.19581 19.6875 3.28125 19.6875H9.1875C9.69347 19.6875 10.1509 19.49 10.5 19.1756C10.8491 19.4906 11.3065 19.6875 11.8125 19.6875H17.7188C18.8042 19.6875 19.6875 18.8042 19.6875 17.7188V11.8125C19.6875 10.7271 18.8042 9.84375 17.7188 9.84375ZM7.21875 9.1875V3.28125C7.21875 2.91966 7.51275 2.625 7.875 2.625H13.7812C14.1435 2.625 14.4375 2.91966 14.4375 3.28125V9.1875C14.4375 9.54909 14.1435 9.84375 13.7812 9.84375H7.875C7.51275 9.84375 7.21875 9.54909 7.21875 9.1875ZM9.1875 18.375H3.28125C2.919 18.375 2.625 18.0803 2.625 17.7188V11.8125C2.625 11.4509 2.919 11.1562 3.28125 11.1562H9.1875C9.54975 11.1562 9.84375 11.4509 9.84375 11.8125V17.7188C9.84375 18.0803 9.54975 18.375 9.1875 18.375ZM18.375 17.7188C18.375 18.0803 18.081 18.375 17.7188 18.375H11.8125C11.4502 18.375 11.1562 18.0803 11.1562 17.7188V11.8125C11.1562 11.4509 11.4502 11.1562 11.8125 11.1562H17.7188C18.081 11.1562 18.375 11.4509 18.375 11.8125V17.7188Z"
                fill="#2D69F6"></path>
              <path
                d="M13.125 8.53172C13.125 8.89397 12.8317 9.18797 12.4688 9.18797H9.84377C9.48086 9.18797 9.18752 8.89397 9.18752 8.53172C9.18752 8.16947 9.48086 7.87547 9.84377 7.87547H10.5V5.79844C10.2959 5.86209 10.0846 5.89819 9.8687 5.90672C9.51105 5.92444 9.2013 5.63765 9.18817 5.27606C9.17439 4.91381 9.45658 4.60865 9.81883 4.59487C9.9632 4.58962 10.103 4.55747 10.2329 4.49906C10.3917 4.42819 10.5355 4.31794 10.6483 4.17947C10.8242 3.96422 11.1149 3.88415 11.3768 3.97603C11.638 4.06922 11.8125 4.31662 11.8125 4.59422V7.87547H12.4688C12.8317 7.87547 13.125 8.16947 13.125 8.53172ZM7.87502 16.4067H6.9123L7.68273 15.6862C7.70177 15.6678 7.72145 15.6474 7.73852 15.6271C8.19723 15.0765 8.33308 14.3546 8.10208 13.6971C7.88092 13.0697 7.36117 12.6169 6.68392 12.4804C6.09395 12.3695 5.46133 12.5152 4.94289 12.8794C4.64627 13.0874 4.57473 13.4969 4.78342 13.7935C4.99211 14.0902 5.40095 14.1623 5.69823 13.953C5.92923 13.7909 6.20289 13.7266 6.45161 13.7725C6.7292 13.8283 6.83223 14.0436 6.86439 14.1328C6.93723 14.3402 6.89523 14.5718 6.75217 14.7602L4.8018 16.5839C4.60492 16.7683 4.54127 17.0538 4.64036 17.3045C4.7388 17.5552 4.98161 17.7199 5.25067 17.7199H7.87567C8.23858 17.7199 8.53192 17.4259 8.53192 17.0636C8.53192 16.7014 8.23858 16.4074 7.87567 16.4074L7.87502 16.4067ZM16.4063 14.1098C16.4063 13.2055 15.6706 12.4692 14.767 12.4692H14.7617C14.4743 12.4692 14.1947 12.5217 13.9276 12.6254C13.7334 12.7015 13.5509 12.8039 13.3842 12.9306C13.0961 13.1497 13.039 13.5612 13.2582 13.85C13.4774 14.1381 13.8882 14.1952 14.1776 13.976C14.2479 13.9222 14.3253 13.8795 14.406 13.8473C14.5189 13.8034 14.6383 13.7811 14.763 13.7811H14.7656C14.9435 13.7811 15.0938 13.9313 15.0938 14.1092C15.0938 14.2903 14.9461 14.4373 14.7656 14.4373H14.4375C14.0746 14.4373 13.7813 14.7313 13.7813 15.0936C13.7813 15.4558 14.0746 15.7498 14.4375 15.7498H14.7656C14.9461 15.7498 15.0938 15.8968 15.0938 16.0779C15.0938 16.2558 14.9435 16.4061 14.7643 16.4061H14.7617C14.6383 16.4061 14.5189 16.3837 14.4073 16.3398C14.3253 16.3076 14.2485 16.2643 14.1776 16.2112C13.8882 15.992 13.4774 16.0484 13.2582 16.3372C13.039 16.6259 13.0961 17.0374 13.3842 17.2566C13.5509 17.3826 13.7334 17.4856 13.9289 17.5617C14.194 17.6654 14.4743 17.7179 14.7604 17.7179H14.7656C15.6706 17.7179 16.4063 16.9816 16.4063 16.0773C16.4063 15.7065 16.2783 15.3679 16.0696 15.0929C16.2776 14.8179 16.4063 14.4793 16.4063 14.1085V14.1098Z"
                fill="#2D69F6"></path>
            </svg>
            <div class="ml-3 w-100 text-left">
              <p class="f-14 o-5 mb-0">{{ $t('searchEquipmentPage.vinNo') }}</p>
              <p class="mb-0 desc f-14">{{ equipment.vin_no }}</p>
              <hr class="mt-2 mb-0">
            </div>
          </div>
          <div class="d-flex mt-2 align-items-center">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M22.125 4.94238H1.875C0.841125 4.94238 0 5.78351 0 6.81738V17.1835C0 18.2173 0.841125 19.0585 1.875 19.0585H22.125C23.1589 19.0585 24 18.2173 24 17.1835C24 15.5063 24 7.12915 24 6.81738C24 5.78351 23.1589 4.94238 22.125 4.94238ZM1.875 5.87988H22.125C22.6419 5.87988 23.0625 6.30045 23.0625 6.81738V7.76637H0.9375V6.81738C0.9375 6.30045 1.35806 5.87988 1.875 5.87988ZM23.0625 15.2969H0.9375V8.70382H23.0625V15.2969ZM22.125 18.1209H1.875C1.35806 18.1209 0.9375 17.7004 0.9375 17.1834V16.2344H23.0625V17.1834C23.0625 17.7004 22.6419 18.1209 22.125 18.1209Z"
                fill="#2D69F6"></path>
              <path
                d="M2.35132 10.5869H4.61294L1.99858 13.5748C1.87746 13.7132 1.84849 13.9096 1.92447 14.0771C2.00046 14.2446 2.16743 14.3522 2.35137 14.3522H5.64602C5.90487 14.3522 6.11477 14.1423 6.11477 13.8834C6.11477 13.6246 5.90487 13.4147 5.64602 13.4147H3.38435L5.99871 10.4268C6.11983 10.2884 6.1488 10.092 6.07282 9.92448C5.99683 9.75699 5.82987 9.64941 5.64597 9.64941H2.35132C2.09243 9.64941 1.88257 9.85927 1.88257 10.1182C1.88257 10.3771 2.09247 10.5869 2.35132 10.5869Z"
                fill="#2D69F6"></path>
              <path
                d="M7.22012 14.2362C7.41488 14.4067 7.71113 14.387 7.88153 14.1921L9.17612 12.7126L10.4707 14.1921C10.6411 14.3869 10.9374 14.4067 11.1321 14.2362C11.3269 14.0658 11.3467 13.7696 11.1762 13.5748L9.79899 12.0008L11.1762 10.4268C11.3467 10.232 11.327 9.93588 11.1322 9.76539C10.9374 9.59491 10.6412 9.61469 10.4708 9.8095L9.17617 11.289L7.88157 9.8095C7.71109 9.61464 7.41493 9.59495 7.22017 9.76539C7.02535 9.93588 7.00562 10.232 7.1761 10.4268L8.55329 12.0008L7.17606 13.5748C7.00557 13.7696 7.02531 14.0658 7.22012 14.2362Z"
                fill="#2D69F6"></path>
              <path
                d="M16.0006 13.4142C15.7417 13.4142 15.5318 13.6241 15.5318 13.883C15.5318 14.1418 15.7417 14.3517 16.0006 14.3517H17.8832C18.1421 14.3517 18.352 14.1418 18.352 13.883C18.352 13.6241 18.1421 13.4142 17.8832 13.4142H17.4107V10.1177C17.4107 9.76972 17.0437 9.54271 16.7323 9.69843L15.791 10.1691C15.5594 10.2849 15.4656 10.5665 15.5813 10.798C15.697 11.0295 15.9786 11.1233 16.2102 11.0076L16.4731 10.8761V13.4142H16.0006Z"
                fill="#2D69F6"></path>
              <path
                d="M20.7072 13.4147H19.7659C19.507 13.4147 19.2971 13.6246 19.2971 13.8834C19.2971 14.1423 19.507 14.3522 19.7659 14.3522H20.7072C21.4847 14.3522 22.1173 13.7197 22.1173 12.9421C22.1173 12.5807 21.9806 12.2506 21.7562 12.0008C21.9806 11.751 22.1173 11.4209 22.1173 11.0595C22.1173 10.282 21.4847 9.64941 20.7072 9.64941H19.7659C19.507 9.64941 19.2971 9.85927 19.2971 10.1182C19.2971 10.3771 19.507 10.5869 19.7659 10.5869H20.7072C20.9678 10.5869 21.1798 10.7989 21.1798 11.0595C21.1798 11.3201 20.9678 11.5321 20.7072 11.5321H20.2365C19.9776 11.5321 19.7677 11.7419 19.7677 12.0008C19.7677 12.2596 19.9776 12.4696 20.2365 12.4696H20.7072C20.9678 12.4696 21.1798 12.6815 21.1798 12.9421C21.1798 13.2027 20.9678 13.4147 20.7072 13.4147Z"
                fill="#2D69F6"></path>
              <path
                d="M12.7061 12.4688H14.118C14.3769 12.4688 14.5868 12.2588 14.5868 12C14.5868 11.7411 14.3769 11.5312 14.118 11.5312H12.7061C12.4472 11.5312 12.2373 11.7411 12.2373 12C12.2373 12.2588 12.4472 12.4688 12.7061 12.4688Z"
                fill="#2D69F6"></path>
            </svg>
            <div class="ml-3 w-100 text-left">
              <p class="f-14 o-5 mb-0">{{ $t('searchEquipmentPage.plateNo') }}</p>
              <p class="mb-0 desc f-14">{{ equipment.plate_no }} <span class="mr-3">{{ equipment.state.name }}</span></p>
              <hr class="mt-2 mb-0">
            </div>
          </div>
          <div class="d-flex mt-2 align-items-center">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_10026_4625)">
                <path
                  d="M13.7172 9.575L21.0589 11.0333C21.6505 11.1583 22.0505 11.6583 22.0505 12.25V20.75C22.0505 21.4417 21.4922 22 20.8005 22H13.3005C13.5339 22 13.7172 21.8167 13.7172 21.5833V21.1667H20.8005C21.0255 21.1667 21.2172 20.9833 21.2172 20.75V12.25C21.2172 12.0583 21.0839 11.8833 20.8922 11.8417L13.7172 10.425V9.575Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M18.3006 13.6667C18.534 13.6667 18.7173 13.85 18.7173 14.0833C18.7173 14.3167 18.534 14.5 18.3006 14.5H16.634C16.4006 14.5 16.2173 14.3167 16.2173 14.0833C16.2173 13.85 16.4006 13.6667 16.634 13.6667H18.3006Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M18.3006 16.1667C18.534 16.1667 18.7173 16.35 18.7173 16.5833C18.7173 16.8167 18.534 17 18.3006 17H16.634C16.4006 17 16.2173 16.8167 16.2173 16.5833C16.2173 16.35 16.4006 16.1667 16.634 16.1667H18.3006Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M18.3006 18.6667C18.534 18.6667 18.7173 18.85 18.7173 19.0833C18.7173 19.3167 18.534 19.5 18.3006 19.5H16.634C16.4006 19.5 16.2173 19.3167 16.2173 19.0833C16.2173 18.85 16.4006 18.6667 16.634 18.6667H18.3006Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M13.7171 21.5833C13.7171 21.8167 13.5338 22 13.3005 22C13.0671 22 12.8838 21.8167 12.8838 21.5833V21.1667V9.91667C12.8838 9.79167 12.9421 9.675 13.0338 9.59167C13.1338 9.51667 13.2588 9.48334 13.3838 9.50834L13.7171 9.575V10.425V21.1667V21.5833Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M12.884 21.1667V21.5833C12.884 21.8167 13.0673 22 13.3006 22H9.96729C10.2006 22 10.384 21.8167 10.384 21.5833V21.1667H12.884Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M10.8006 6.16667C11.034 6.16667 11.2173 6.35001 11.2173 6.58334C11.2173 6.81667 11.034 7.00001 10.8006 7.00001H9.13395C8.90062 7.00001 8.71729 6.81667 8.71729 6.58334C8.71729 6.35001 8.90062 6.16667 9.13395 6.16667H10.8006Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M11.2173 9.08334C11.2173 9.31667 11.034 9.50001 10.8006 9.50001H9.13395C8.90062 9.50001 8.71729 9.31667 8.71729 9.08334C8.71729 8.85001 8.90062 8.66667 9.13395 8.66667H10.8006C11.034 8.66667 11.2173 8.85001 11.2173 9.08334Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M10.8006 11.1667C11.034 11.1667 11.2173 11.35 11.2173 11.5833C11.2173 11.8167 11.034 12 10.8006 12H9.13395C8.90062 12 8.71729 11.8167 8.71729 11.5833C8.71729 11.35 8.90062 11.1667 9.13395 11.1667H10.8006Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M10.8006 13.6667C11.034 13.6667 11.2173 13.85 11.2173 14.0833C11.2173 14.3167 11.034 14.5 10.8006 14.5H9.13395C8.90062 14.5 8.71729 14.3167 8.71729 14.0833C8.71729 13.85 8.90062 13.6667 9.13395 13.6667H10.8006Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M7.05054 14.0833C7.05054 14.3167 6.8672 14.5 6.63387 14.5H4.9672C4.73387 14.5 4.55054 14.3167 4.55054 14.0833C4.55054 13.85 4.73387 13.6667 4.9672 13.6667H6.63387C6.8672 13.6667 7.05054 13.85 7.05054 14.0833Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M6.63387 6.16667C6.8672 6.16667 7.05054 6.35001 7.05054 6.58334C7.05054 6.81667 6.8672 7.00001 6.63387 7.00001H4.9672C4.73387 7.00001 4.55054 6.81667 4.55054 6.58334C4.55054 6.35001 4.73387 6.16667 4.9672 6.16667H6.63387Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M6.63387 8.66667C6.8672 8.66667 7.05054 8.85001 7.05054 9.08334C7.05054 9.31667 6.8672 9.50001 6.63387 9.50001H4.9672C4.73387 9.50001 4.55054 9.31667 4.55054 9.08334C4.55054 8.85001 4.73387 8.66667 4.9672 8.66667H6.63387Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M6.63387 11.1667C6.8672 11.1667 7.05054 11.35 7.05054 11.5833C7.05054 11.8167 6.8672 12 6.63387 12H4.9672C4.73387 12 4.55054 11.8167 4.55054 11.5833C4.55054 11.35 4.73387 11.1667 4.9672 11.1667H6.63387Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M9.55046 17.4167C9.55046 17.1833 9.35879 17 9.13379 17H6.63379C6.40046 17 6.21712 17.1833 6.21712 17.4167V21.1667H5.38379V17.4167C5.38379 16.725 5.94212 16.1667 6.63379 16.1667H9.13379C9.82546 16.1667 10.3838 16.725 10.3838 17.4167V21.1667H9.55046V17.4167Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M6.21712 21.1667H9.55046H10.3838V21.5833C10.3838 21.8167 10.2005 22 9.96712 22H5.80046C5.56712 22 5.38379 21.8167 5.38379 21.5833V21.1667H6.21712Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
                <path
                  d="M3.50887 2.16667L12.6672 3.55833C13.2755 3.65833 13.7172 4.175 13.7172 4.79167V9.575L13.3839 9.50833C13.2589 9.48333 13.1339 9.51667 13.0339 9.59167C12.9422 9.675 12.8839 9.79167 12.8839 9.91667V4.79167C12.8839 4.58333 12.7339 4.40833 12.5339 4.375L3.37554 2.99167C3.35054 2.98333 3.32554 2.98333 3.30054 2.98333C3.20054 2.98333 3.10887 3.01667 3.03387 3.08333C2.93387 3.16667 2.88387 3.275 2.88387 3.4V20.75C2.88387 20.9833 3.07554 21.1667 3.30054 21.1667H5.38387V21.5833C5.38387 21.8167 5.5672 22 5.80054 22H3.30054C2.60887 22 2.05054 21.4417 2.05054 20.75V3.4C2.05054 3.03333 2.20887 2.68333 2.4922 2.45C2.77554 2.20833 3.1422 2.10833 3.50887 2.16667Z"
                  fill="#2D69F6" stroke="#2D69F6" stroke-width="0.5" />
              </g>
              <defs>
                <clipPath id="clip0_10026_4625">
                  <rect width="20" height="20" fill="white" transform="translate(2.05054 2)" />
                </clipPath>
              </defs>
            </svg>

            <div class="ml-3 w-100 text-left">
              <p class="f-14 o-5 mb-0">{{ $t('searchEquipmentPage.company') }}</p>
              <p class="mb-0 desc f-14 mb-0">{{ equipment.company.name }}</p>
              <p class="mb-0 desc f-14 mb-0">{{ equipment.company.phone }}</p>
              <p class="mb-0 desc f-14">{{ equipment.company.email }}</p>
              <hr class="mt-2 mb-0">
            </div>
          </div>
        </div>
        <b-row v-else>
          <b-col>
            <h1>{{ $t('searchEquipmentPage.noRecord') }}</h1>
          </b-col>
        </b-row>
      </div>
      <div class="mt-3" v-if="showInfo && items.length > 0">
       <div class="bg-[#EAF0FE] px-3 text-left f-18 font-weight-bold border-b border-t border-[#F1F0F4] d-flex align-items-center h-[50px]">
        {{ $t('searchEquipmentPage.sectionEquipment') }}
       </div>
        <div @click="openLink(docs.id)"
          class="equipment-details-section equipment-details-section-2 shadow-none equipment-detail-section cursor-pointer mb-3"
          v-for="(docs, index) in items" :key="index">
          <div class="bg-[#EAF0FE] rounded-[50%] d-flex align-items-center justify-content-center w-[40px] h-[40px]">
            <svg v-if="docs.document.includes('.pdf')" width="17" height="22" viewBox="0 0 17 22" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.53368 13.4726C4.33818 13.4726 4.20643 13.4918 4.13843 13.5109V14.7625C4.21918 14.7816 4.32011 14.7869 4.4593 14.7869C4.96824 14.7869 5.28168 14.5298 5.28168 14.0953C5.28168 13.7064 5.0118 13.4726 4.53368 13.4726ZM8.23859 13.4854C8.02609 13.4854 7.88797 13.5045 7.80616 13.5236V16.2968C7.88797 16.3159 8.01972 16.3159 8.13872 16.3159C9.00678 16.3223 9.57203 15.8441 9.57203 14.8326C9.57841 13.9508 9.06309 13.4854 8.23859 13.4854Z"
                fill="#2D69F6" />
              <path
                d="M10.625 0H2.125C1.56142 0 1.02091 0.223879 0.622402 0.622402C0.22388 1.02091 0 1.56142 0 2.125V19.125C0 19.6885 0.22388 20.229 0.622402 20.6276C1.02091 21.0261 1.56142 21.25 2.125 21.25H14.875C15.4385 21.25 15.979 21.0261 16.3776 20.6276C16.7761 20.229 17 19.6885 17 19.125V6.375L10.625 0ZM5.84163 15.0769C5.51331 15.385 5.02881 15.5231 4.46462 15.5231C4.35523 15.5243 4.24589 15.5179 4.13737 15.504V17.0191H3.1875V12.8371C3.61617 12.7732 4.04931 12.7441 4.48269 12.75C5.0745 12.75 5.49525 12.8626 5.77894 13.0889C6.04881 13.3036 6.23156 13.6552 6.23156 14.0696C6.2305 14.4861 6.09238 14.8378 5.84163 15.0769ZM9.88656 16.5166C9.44031 16.8874 8.76138 17.0637 7.93156 17.0637C7.43431 17.0637 7.08262 17.0319 6.84356 17V12.8382C7.27239 12.7756 7.70536 12.7461 8.13875 12.75C8.94306 12.75 9.46581 12.8945 9.87381 13.2026C10.3148 13.5299 10.591 14.0516 10.591 14.8006C10.591 15.6113 10.2946 16.1712 9.88656 16.5166ZM13.8125 13.5681H12.1848V14.5361H13.7062V15.3159H12.1848V17.0202H11.2221V12.7819H13.8125V13.5681ZM10.625 7.4375H9.5625V2.125L14.875 7.4375H10.625Z"
                fill="#2D69F6" />
            </svg>

            <svg v-else width="17" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.75 0H2.15C1.57979 0 1.03292 0.226513 0.629724 0.629724C0.226513 1.03292 0 1.57979 0 2.15V19.35C0 19.9202 0.226513 20.467 0.629724 20.8703C1.03292 21.2735 1.57979 21.5 2.15 21.5H15.05C15.6202 21.5 16.167 21.2735 16.5703 20.8703C16.9735 20.467 17.2 19.9202 17.2 19.35V6.45L10.75 0ZM5.63193 15.5294C5.63193 16.7678 5.0396 17.2 4.08607 17.2C3.86032 17.2 3.56362 17.1613 3.3712 17.0957L3.47977 16.3035C3.6163 16.3486 3.79045 16.3809 3.98395 16.3809C4.39675 16.3809 4.65368 16.1938 4.65368 15.5166V12.7828H5.633L5.63193 15.5294ZM9.17297 15.1371C8.8365 15.4521 8.342 15.595 7.7615 15.595C7.6325 15.595 7.5164 15.5875 7.4261 15.5746V17.128H6.45215V12.8409C6.89182 12.7747 7.33623 12.7449 7.78085 12.7517C8.38607 12.7517 8.81822 12.8667 9.1074 13.0989C9.38583 13.3182 9.57287 13.6794 9.57287 14.1051C9.57287 14.5308 9.4299 14.892 9.17297 15.1371ZM13.8288 16.9291C13.5278 17.0323 12.9527 17.1742 12.3786 17.1742C11.5863 17.1742 11.0123 16.9743 10.6124 16.5873C10.2136 16.2132 9.99427 15.6466 9.99965 15.0081C10.0072 13.5633 11.0564 12.7388 12.4818 12.7388C13.0419 12.7388 13.4751 12.8495 13.6869 12.9516L13.4816 13.7374C13.2429 13.6342 12.9473 13.5504 12.47 13.5504C11.6519 13.5504 11.0316 14.0148 11.0316 14.9565C11.0316 15.852 11.5939 16.3809 12.398 16.3809C12.6248 16.3809 12.8043 16.3551 12.8828 16.3153V15.4058H12.212V14.6394H13.8288V16.9291ZM10.75 7.525H9.675V2.15L15.05 7.525H10.75Z"
                fill="#2D69F6" />
              <path
                d="M7.8313 13.4932C7.63135 13.4932 7.4959 13.5125 7.42603 13.5319V14.8143C7.5088 14.8337 7.61308 14.8391 7.75605 14.8391C8.27635 14.8391 8.59885 14.5746 8.59885 14.1306C8.59885 13.7307 8.32258 13.4932 7.8313 13.4932Z"
                fill="#2D69F6" />
            </svg>

          </div>
          <div class="ml-3">
            <p class="mb-0 text-left mb-1 font-weight-bold">
              {{ docs.description ? docs.description : "-" }}
            </p>
            <p class="f-12 mb-0 text-left" :class="docs.expired_status">
              {{
                docs.expiry_date
                ? $t('searchEquipmentPage.expiringPrefix', { date: moment(docs.expiry_date).format("ll") })
                : "-"
              }}
            </p>
          </div>
          <svg width="20" class="ml-auto" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4849_341)">
              <path
                d="M10 0C4.48582 0 0 4.48582 0 10C0 15.5142 4.48582 20 10 20C15.5142 20 20 15.5142 20 10C20 4.48582 15.5142 0 10 0ZM13.0892 10.5892L8.9225 14.7558C8.76 14.9183 8.54668 15 8.33332 15C8.12 15 7.90664 14.9183 7.74414 14.7558C7.41832 14.43 7.41832 13.9033 7.74414 13.5775L11.3217 10L7.74418 6.4225C7.41836 6.09668 7.41836 5.57 7.74418 5.24418C8.07 4.91836 8.59668 4.91836 8.9225 5.24418L13.0892 9.41086C13.415 9.73668 13.415 10.2633 13.0892 10.5892Z"
                fill="#2D69F6" />
            </g>
            <defs>
              <clipPath id="clip0_4849_341">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div class="mt-3" v-if="showInfo && companyItems.length > 0">
        <div class="bg-[#EAF0FE] px-3 text-left f-18 font-weight-bold border-b border-t border-[#F1F0F4] d-flex align-items-center h-[50px]">
        {{ $t('searchEquipmentPage.sectionCompany') }}
       </div>
        <div @click="openLink(docs.id)"
          class="equipment-details-section equipment-details-section-2 shadow-none equipment-detail-section cursor-pointer mb-3"
          v-for="(docs, index) in companyItems" :key="index">
          <div class="bg-[#EAF0FE] rounded-[50%] d-flex align-items-center justify-content-center w-[40px] h-[40px]">
            <svg v-if="docs.document.includes('.pdf')" width="17" height="22" viewBox="0 0 17 22" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.53368 13.4726C4.33818 13.4726 4.20643 13.4918 4.13843 13.5109V14.7625C4.21918 14.7816 4.32011 14.7869 4.4593 14.7869C4.96824 14.7869 5.28168 14.5298 5.28168 14.0953C5.28168 13.7064 5.0118 13.4726 4.53368 13.4726ZM8.23859 13.4854C8.02609 13.4854 7.88797 13.5045 7.80616 13.5236V16.2968C7.88797 16.3159 8.01972 16.3159 8.13872 16.3159C9.00678 16.3223 9.57203 15.8441 9.57203 14.8326C9.57841 13.9508 9.06309 13.4854 8.23859 13.4854Z"
                fill="#2D69F6" />
              <path
                d="M10.625 0H2.125C1.56142 0 1.02091 0.223879 0.622402 0.622402C0.22388 1.02091 0 1.56142 0 2.125V19.125C0 19.6885 0.22388 20.229 0.622402 20.6276C1.02091 21.0261 1.56142 21.25 2.125 21.25H14.875C15.4385 21.25 15.979 21.0261 16.3776 20.6276C16.7761 20.229 17 19.6885 17 19.125V6.375L10.625 0ZM5.84163 15.0769C5.51331 15.385 5.02881 15.5231 4.46462 15.5231C4.35523 15.5243 4.24589 15.5179 4.13737 15.504V17.0191H3.1875V12.8371C3.61617 12.7732 4.04931 12.7441 4.48269 12.75C5.0745 12.75 5.49525 12.8626 5.77894 13.0889C6.04881 13.3036 6.23156 13.6552 6.23156 14.0696C6.2305 14.4861 6.09238 14.8378 5.84163 15.0769ZM9.88656 16.5166C9.44031 16.8874 8.76138 17.0637 7.93156 17.0637C7.43431 17.0637 7.08262 17.0319 6.84356 17V12.8382C7.27239 12.7756 7.70536 12.7461 8.13875 12.75C8.94306 12.75 9.46581 12.8945 9.87381 13.2026C10.3148 13.5299 10.591 14.0516 10.591 14.8006C10.591 15.6113 10.2946 16.1712 9.88656 16.5166ZM13.8125 13.5681H12.1848V14.5361H13.7062V15.3159H12.1848V17.0202H11.2221V12.7819H13.8125V13.5681ZM10.625 7.4375H9.5625V2.125L14.875 7.4375H10.625Z"
                fill="#2D69F6" />
            </svg>

            <svg v-else width="17" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.75 0H2.15C1.57979 0 1.03292 0.226513 0.629724 0.629724C0.226513 1.03292 0 1.57979 0 2.15V19.35C0 19.9202 0.226513 20.467 0.629724 20.8703C1.03292 21.2735 1.57979 21.5 2.15 21.5H15.05C15.6202 21.5 16.167 21.2735 16.5703 20.8703C16.9735 20.467 17.2 19.9202 17.2 19.35V6.45L10.75 0ZM5.63193 15.5294C5.63193 16.7678 5.0396 17.2 4.08607 17.2C3.86032 17.2 3.56362 17.1613 3.3712 17.0957L3.47977 16.3035C3.6163 16.3486 3.79045 16.3809 3.98395 16.3809C4.39675 16.3809 4.65368 16.1938 4.65368 15.5166V12.7828H5.633L5.63193 15.5294ZM9.17297 15.1371C8.8365 15.4521 8.342 15.595 7.7615 15.595C7.6325 15.595 7.5164 15.5875 7.4261 15.5746V17.128H6.45215V12.8409C6.89182 12.7747 7.33623 12.7449 7.78085 12.7517C8.38607 12.7517 8.81822 12.8667 9.1074 13.0989C9.38583 13.3182 9.57287 13.6794 9.57287 14.1051C9.57287 14.5308 9.4299 14.892 9.17297 15.1371ZM13.8288 16.9291C13.5278 17.0323 12.9527 17.1742 12.3786 17.1742C11.5863 17.1742 11.0123 16.9743 10.6124 16.5873C10.2136 16.2132 9.99427 15.6466 9.99965 15.0081C10.0072 13.5633 11.0564 12.7388 12.4818 12.7388C13.0419 12.7388 13.4751 12.8495 13.6869 12.9516L13.4816 13.7374C13.2429 13.6342 12.9473 13.5504 12.47 13.5504C11.6519 13.5504 11.0316 14.0148 11.0316 14.9565C11.0316 15.852 11.5939 16.3809 12.398 16.3809C12.6248 16.3809 12.8043 16.3551 12.8828 16.3153V15.4058H12.212V14.6394H13.8288V16.9291ZM10.75 7.525H9.675V2.15L15.05 7.525H10.75Z"
                fill="#2D69F6" />
              <path
                d="M7.8313 13.4932C7.63135 13.4932 7.4959 13.5125 7.42603 13.5319V14.8143C7.5088 14.8337 7.61308 14.8391 7.75605 14.8391C8.27635 14.8391 8.59885 14.5746 8.59885 14.1306C8.59885 13.7307 8.32258 13.4932 7.8313 13.4932Z"
                fill="#2D69F6" />
            </svg>

          </div>
          <div class="ml-3">
            <p class="mb-0 text-left mb-1 font-weight-bold">
              {{ docs.description ? docs.description : "-" }}
            </p>
            <p class="f-12 mb-0 text-left" :class="docs.expired_status">
              {{
                docs.expiry_date
                ? $t('searchEquipmentPage.expiringPrefix', { date: moment(docs.expiry_date).format("ll") })
                : "-"
              }}
            </p>
          </div>
          <svg width="20" class="ml-auto" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4849_341)">
              <path
                d="M10 0C4.48582 0 0 4.48582 0 10C0 15.5142 4.48582 20 10 20C15.5142 20 20 15.5142 20 10C20 4.48582 15.5142 0 10 0ZM13.0892 10.5892L8.9225 14.7558C8.76 14.9183 8.54668 15 8.33332 15C8.12 15 7.90664 14.9183 7.74414 14.7558C7.41832 14.43 7.41832 13.9033 7.74414 13.5775L11.3217 10L7.74418 6.4225C7.41836 6.09668 7.41836 5.57 7.74418 5.24418C8.07 4.91836 8.59668 4.91836 8.9225 5.24418L13.0892 9.41086C13.415 9.73668 13.415 10.2633 13.0892 10.5892Z"
                fill="#2D69F6" />
            </g>
            <defs>
              <clipPath id="clip0_4849_341">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>

    </div>
    <b-modal id="pinModal" centered hide-footer :title="$t('searchEquipmentPage.pinModalTitle')" :no-close-on-backdrop="true" size="sm" no-close-on-esc>
      <template #modal-header="{ close }">
        <h5 class="modal-title">{{ $t('searchEquipmentPage.pinModalHeader') }}</h5>
        <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
          {{ $t('searchEquipmentPage.closeModal') }}
        </b-button>
      </template>
      <div class="d-block text-center">
        <b-row>
          <b-col cols="12">
            <b-form @submit.prevent="handleFormSubmit">
              <b-form-group :label="$t('searchEquipmentPage.pinNumberLabel')" class="text-left">
                <b-form-input type="text" v-model="form.pin_code" :placeholder="$t('searchEquipmentPage.pinNumberPlaceholder')" required pattern="\d{4}"
                  :title="$t('searchEquipmentPage.pinNumberTitle')"></b-form-input>
                <p v-if="errors.pin_code" class="field-error">
                  {{ $t('searchEquipmentPage.fieldRequired') }}
                </p>
              </b-form-group>
              <b-button type="submit" variant="primary" class="save w-100">{{ $t('searchEquipmentPage.submit') }}</b-button>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as moment from "moment-timezone";

export default {
  name: "search-equipment",
  data() {
    return {
      moment,
      country: 1,
      items: [],
      companyItems: [],
      showInfo: false,
      emptyMessage: "",
      equipment: {},
      errors: {
        pin_code: false,
      },
      form: {
        pin_code: "",
      },
    };
  },
  computed: {
    ...mapGetters(["currentEquipment", "allCountries", "companyPinCode"]),
  },
  methods: {
    ...mapActions([
      "getAllCountries",
      "searchEquipment",
      "retrieveDocument",
      "setNotification",
      "getEquipment",
    ]),
    handleFormSubmit() {
      if (this.equipment.company.pin_code === this.form.pin_code) {
        this.showInfo = true
        this.$bvModal.hide("pinModal");
      }
    },
    getCountry(id) {
      return this.allCountries.filter((country) => country.id === id)[0].name;
    },
    async searchEq(query) {
      try {
        const equipments = await this.searchEquipment(query);
        if (equipments.length > 0) {
          this.equipment = equipments[0];
          this.items = this.equipment?.docs.map((item) => {
            if (item.expiry_date) {
              let color;
              const currentDate = new Date();
              const expiryDate = new Date(item.expiry_date);
              const diffDays = parseInt(
                (expiryDate - currentDate) / (1000 * 60 * 60 * 24),
                10
              );
              if (diffDays > 30) {
                color = "black-text";
              } else if (diffDays <= 30 && diffDays >= 1) {
                color = "yellow-text";
              } else color = "red-text";
              return { ...item, expired_status: color };
            } else return { ...item };
          });
          this.companyItems = this.equipment?.company_docs.map((item) => {
            if (item.expiry_date) {
              let color;
              const currentDate = new Date();
              const expiryDate = new Date(item.expiry_date);
              const diffDays = parseInt(
                (expiryDate - currentDate) / (1000 * 60 * 60 * 24),
                10
              );
              if (diffDays > 30) {
                color = "black-text";
              } else if (diffDays <= 30 && diffDays >= 1) {
                color = "yellow-text";
              } else color = "red-text";
              return { ...item, expired_status: color };
            } else return { ...item };
          });
        } else {
          this.items = [];
          this.companyItems = []
          this.equipment = {};
        }
      } catch (error) {
        if (typeof error === "object") {
          this.errors = error;
          // eslint-disable-next-line no-ex-assign
        }
        this.items = [];
        this.companyItems = []
        this.equipment = {};
      }
    },
    async openLink(id) {
      if (!localStorage.getItem("userSelectedCompany")) localStorage.setItem("userSelectedCompany", this.equipment.company.id)
      const doc = await this.retrieveDocument(id);
      window.location.href = doc.document
    },
  },
  destroyed() {
    document.querySelector("body").classList.remove("bg-white-2");
  },
  async mounted() {
    document.querySelector("body").classList.add("bg-white-2")
    try {
      if (this.$route.query.equipment) {
        await this.searchEq(`equipment_id=${this.$route.query.equipment}`);
        if (this.equipment.company.pin_code && !this.companyPinCode) {
          this.$bvModal.show("pinModal");
        }
        else this.showInfo = true
        await this.getAllCountries();
      }
    } catch (error) {
      console.log(error);
    }
  },
};
</script>

<style>
.equipment-details-section {
  box-shadow: 0px 4px 50px 0px rgba(0, 0, 0, 0.10);
  border-radius: 5px;
}

.equipment-details-section-2 {
  border-bottom: 1px solid rgb(230, 232, 236);
}

.search-equipment-page .main-search {
  background-color: white;
}

#vs1__combobox {
  min-height: 40px;
}

.w-\[40px\] {
  width: 40px;
}

.h-\[40px\] {
  height: 40px;
}
.h-\[50px\] {
  height: 50px;
}

.main-search {
  padding: 30px 132px !important;
}

.rounded-\[50\%\] {
  border-radius: 50%;
}

.bg-\[\#EAF0FE\] {
  background-color: rgb(234, 240, 254);
}

.search_equipment {
  background-color: #000 !important;
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
  position: fixed;
  left: 0;
  right: 0;
  z-index: 6;
  padding: 10px 0px;
  top: 0;
}

.bg-primary-2 {
  background-color: var(--btn-bg-color) !important;
}

.search_card {
  width: 520px;
  margin: auto;
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.1);
}

.search_card p {
  width: 100%;
  /* border-bottom: 1px solid rgba(0, 0, 0, 30%); */
  line-height: 0.05em;
  margin: 30px 0px;
  padding-top: 12px;
}

.search_card p span {
  background-color: #fff;
  padding: 0px 10px;
  color: rgba(0, 0, 0, 60%);
  font-weight: 100;
  font-size: var(--small);
}

.search_card input,
.search_card input::placeholder,
.search_card input:active,
.search_card input:focus {
  color: rgba(0, 0, 0, 60%);
}

.search_card .search,
.search_card .search:hover,
.search_card .search:focus,
.search_card .search:active {
  background-color: var(--btn-bg-color);
}

.left_side,
.right_side {
  display: flex;
  line-height: 30px;
  color: var(--black);
  font-size: var(--small);
}

.left_side .heading,
.right_side .heading {
  width: 250px;
  text-align: left;
  font-weight: 600;
}

.search-equipment-page .select_arrow {
  position: relative;
}

.equipment-detail-section {
  padding: 13px 25px;
  display: flex;
  align-items: center;
}
.bg-\[\#EAF0FE\] {
    background-color: rgb(234, 240, 254);
}
.border-\[\#F1F0F4\] {
    border-color: rgb(241,240,244);
}
.border-t {
    border-top-width: 1px;
}

.border-b {
    border-bottom-width: 1px;
}
.search-equipment-page .select_arrow svg {
  position: absolute;
  top: 40px;
  right: 10px;
}

@media (max-width: 991px) {

  .left_side .heading,
  .right_side .heading {
    width: 150px;
  }
}

@media (max-width: 767px) {

  .left_side,
  .right_side {
    justify-content: space-between;
  }

  .main-search {
    padding: 30px !important;
  }
}

@media (max-width: 575px) {
  .search_card {
    width: auto;
  }
}

@media (max-width: 500px) {

  .left_side,
  .right_side {
    display: block !important;
  }

  .left_side .heading,
  .right_side .heading {
    width: auto;
    text-align: left;
  }

  .left_side .desc,
  .right_side .desc {
    text-align: left;
  }

  .equipment-detail-section>div>p {
    width: 200px;
  }

}
</style>
